export var PROFILE_ACTIONS={AUTH_START:'AUTH_START',AUTH_SUCCESS:'AUTH_SUCCESS',PROFILE_UPDATED:'PROFILE_UPDATED',AUTH_FAILURE:'AUTH_FAILURE',LOGOUT:'LOGOUT'};